import api from 'src/config/api';
import {
	IChangePasswordFormData,
	IProfileFormData,
} from 'src/features/profile/domain/types';
import { IUser } from 'src/features/user';

export const userProfileApi = {
	getUserProfile: async (): Promise<IUser> => {
		const response = await api.get('/api/v1/profile');
		return response.data;
	},

	updateUserProfile: async (
		requestData: IProfileFormData,
	): Promise<IUser> => {
		const response = await api.patch('/api/v1/profile', requestData);
		return response.data;
	},

	changePassword: async (
		requestData: IChangePasswordFormData,
	): Promise<void> => {
		const response = await api.post('api/v1/password/change', requestData);
		return response.data;
	},
};
